export default {
  departments: [],
}
